/***
* Add by jfzhu
* created:20190805
* 注:商家联盟拓客首页
*/
<template>
  <div class="item-div">
    <div class="backimg">
      <img src="../../resource/img/Nipic_12106414_20160922174257880038.png">
    </div>
    <div class="listinput">
      <div class="listmenu">
        <div class="asd">
          <div class="title">卡号</div>
          <div class="cardnumber">
            <input @focusout="getBank()" type="text" v-model="saveForm.bankCard" maxlength="19" placeholder="请输入银行卡号"/>
          </div>
        </div>
      </div>
      <div class="listmenu">
        <div class="asd">
          <div class="title">姓名</div>
          <div class="cardnumber">
            <input placeholder="请输入姓名" v-model="saveForm.bankUserName"/>
          </div>
        </div>
      </div>
      <div class="listmenu">
        <div class="asd">
          <div class="title">银行卡</div>
          <div class="cardnumber">{{saveForm.bankName}}</div>
        </div>
      </div>
      <div class="listmenu">
        <div class="asd">
          <div class="title">卡类型</div>
          <div class="cardnumber">{{cardTypeName}}</div>
        </div>
      </div>
      <div class="listmenu">
        <div class="asd">
          <div class="title">手机号</div>
          <div class="cardnumber">
            <input type="number" v-model="saveForm.bankPhone" placeholder="请输入银行预留手机号"/>
          </div>
        </div>
      </div>
    </div>
    <div class="btn" @click="sub()">提交</div>
  </div>
</template>

<script>

export default {
  name: 'MerTokerAddBankCard',
  data () {
    return {
      saveForm: {
        id: null,
        bankCard: '',
        bankType: 1,
        uid: null,
        bankUserName: '',
        bankPhone: '',
        merId: null,
        storeId: null,
        bankCode: '',
        bankName: ''
      },
      cardType: '',
      cardTypeName: '',
      status: 0,
      queryData: {}
    }
  },
  created () {
    this.queryData = this.$route.query
  },
  methods: {
    getBank () {
      if (!this.$util.isArrOrNull(this.saveForm.bankCard)) {
        this.$getBankCardInfo.getBankBin(this.saveForm.bankCard, (err, data) => {
          if (!err) {
            this.status = 1
            this.saveForm.bankName = data.bankName
            this.saveForm.bankCode = data.bankCode
            this.cardTypeName = data.cardTypeName
            this.cardType = data.cardType
          } else {
            this.status = 0
            alert('请输入正确的银行卡号')
          }
        })
      }
    },

    sub: function () {
      if (this.cardType != 'DC') {
        alert('不支持该类型的银行卡，请更换')
      }
      if (this.status == 1) {
        if (this.saveForm.bankUserName != '' && this.saveForm.bankPhone != '') {
          this.saveForm.uid = this.queryData.uid
          this.saveForm.merId = this.queryData.merId
          this.saveForm.storeId = this.queryData.merId
          this.$api.post({
            url: '/system/bank-user/mer/save',
            data: this.saveForm,
            login: false
          }).then(res => {
            if (res.data != null) {
              this.$router.go(-1)
            }
          })
        } else {
          alert('请将信息填写完整')
        }
      } else {
        alert('请输入正确的银行卡号')
      }
    },
  }
}

</script>

<style scoped>
  .item-div {
    width: 100%;
    height: auto;
    margin-top: 40px;
  }

  .btn {
    width: 70%;
    height: 40px;
    margin-left: 15%;
    margin-top: 150px;
    text-align: center;
    line-height: 40px;
    background: linear-gradient(to right, #7270AB, #9C66A8); /* 标准的语法 */
    border-radius: 20px;
    font-size: 17px;
    color: #fff;
  }

  input:focus {
    background: none;
    outline: none;
    border: none;
  }

  input {
    width: 100%;
    height: 100%;
    border: none;
    font-size: 17px;
  }

  .listmenu {
    width: 100%;
  }

  .asd {
    width: 90%;
    height: 50px;
    margin-left: 5%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .title, .cardnumber {
    float: left;
    line-height: 25px;
    font-size: 17px;
  }

  .title {
    width: 30%;
  }

  .cardnumber {
    width: 70%;
  }

  .listinput {
    width: 90%;
    height: 250px;
    margin-left: 5%;
    background-color: #fff;
    border-radius: 10px;
    margin-top: -150px;
    position: absolute;
    z-index: 2;
  }


  .backimg {
    width: 100%;
    height: 200px;
  }

  .backimg > img {
    width: 100%;
    height: 200px;
  }

</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerAddBankCard.vue